<template>
  <div id="app">
    <header id="header" >
      
      <button class="hamburger hamburger--collapse" type="button" v-on:click="toggleMenu">
        <span class="hamburger-box">
          <span class="hamburger-inner"></span>
        </span>
      </button>
      
      
      <div class="header-group">
        <a href="#!" v-on:click="toggleMenu()" class="openmenu">Menu</a>
        <a id="backhome" href="/"><img alt="Konrad Köster Fruchtgroßhandel" src="../assets/kk-logo-red.svg"></a>
      </div>
      <search :items="products"></search>
      <nav id="metanav">
        
        <router-link to="/"><i class="icon icon-search mobile-icon-search"></i></router-link>

        <router-link v-if="user" to="/user" :class=" `userdata ${ userdatasubm ? 'usersubm' : 'n' } `"><i class="icon icon-user mobile-icon-user"></i> <span class="kdn">{{user.username}}</span></router-link>
        <router-link v-if="user" to="/basket"><i :class=" 'icon icon-basket ' + ( user.basket.length > 0 ? 'icon-basket-full' :'' )"></i><span class="counter" v-if="user.basket.length > 0">{{user.basket.length}}</span></router-link>
        <router-link v-if="user" to="/favorites"><i :class=" 'icon icon-favourite ' + ( user.fav.length > 0 ? 'icon-favourite-full' :'' )"></i><span class="counter" v-if="user.fav.length > 0">{{user.fav.length}}</span></router-link>

<!--         <router-link to="/about" class="user"><i class="icon icon-user"></i></router-link> -->
<!--         <router-link to="/shop"><i class="icon icon-help"></i></router-link> -->
        <router-link v-if="user" to="/login" title="Logout"><i class="icon icon-logout mobile-icon-logout"></i></router-link>
      </nav>
    </header>
    <main id="maincontent">

        <div v-if="alert.message" :class="`alert ${alert.type}`">{{alert.message}}</div>

        <div id="sidebar" :class=" mobilemenu ? 'mobilemenuopen' : '' ">
          <nav id="productnav">
            <div class="navbox" v-on:click="closeMenu()">
              <router-link :to="{ name: 'CategoriesPage', params: { q: 'gemuese' }}"   
              ><span class="link-label ">Gemüse</span><img :src="`/upload/content/menu/button_gemuese.svg`"></router-link>
              <router-link :to="{ name: 'CategoriesPage', params: { q: 'fruechte' }}"><span class="link-label ">Früchte</span><img :src="`/upload/content/menu/button_fruechte.svg`"></router-link>
              <router-link :to="{ name: 'CategoriesPage', params: { q: 'salate-kraeuter-mehr' }}"><span class="link-label ">Salate, Kräuter & mehr</span><img :src="`/upload/content/menu/button_salate.svg`"></router-link>
              <router-link :to="{ name: 'CategoriesPage', params: { q: 'convenience' }}"><span class="link-label ">Convenience</span><img :src="`/upload/content/menu/button_convenience.svg`"></router-link>
              <router-link :to="{ name: 'BioPage', params: { q: 'bio' }}"><span class="link-label ">BIO</span><img :src="`/upload/content/menu/button_bio.svg`"></router-link>
            </div>
          </nav>
        </div>

        <router-view></router-view>

        <footer id="footer">
           <div class="columns flex valign-top wrap ">
              <div class="column">
                  © 2020 Konrad Koester GmbH <nav><a href="https://kkoester.de/impressum" target="_blank" rel="noopener">Impressum</a> • <a href="https://kkoester.de/datenschutz" target="_blank" rel="noopener">Datenschutz</a></nav>
              </div>
           </div>
        </footer>
    
    </main>
    
    


<div id="fastcontact">
  <a href="#!" class="fastcontact-trigger" v-on:click="toggleContact"></a>
  <div class="contact-info-box" id="contact_info_box" v-on:click="toggleContact">
    <div class="contact-info-box-inner">
    <div class="contact-info-box-content">
      <h2>Wir sind für Sie da</h2>
    </div>
    <VueSlickCarousel v-bind="slickSettings" class="contact_images">
      <div><img src="https://kkoester.de/wp-content/uploads/2020/08/KK_HP_G_SADRI.jpg"></div>
      <div><img src="https://kkoester.de/wp-content/uploads/2020/08/KK_HP_G_MUSTAFA.jpg"></div>
      <div><img src="https://kkoester.de/wp-content/uploads/2020/08/KK_HP_G_BENNI.jpg"></div>
    </VueSlickCarousel>      
    <div class="contact-info-box-content">
    <p>Von 00.00 Uhr bis 13.00 Uhr erreichen Sie uns persönlich.</p>
    <p>Von 13.00 Uhr bis 24.00 Uhr erreichen Sie uns per E-Mail, Anrufbeantworter und Fax.</p>
    <p>T: <a href="tel:+492114155773">0211 4155773</a><br>
        F: 0211 41557750<br>
        E: <a href="mailto:info@kkoester.de">info@kkoester.de</a>
    </p>
    </div>
    </div>
  </div>
</div>




  </div>

</template>

<script>
import Search         from '../components/Search'
import products       from '../data/etar2.json';
import categories     from '../data/categories.json';

import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
    name: 'app',
    components: {
      Search,
      VueSlickCarousel,
    },
    data() {
      return {
        products: products,
        categories: categories,
        mobilemenu: false,
        userdatasubm: false,
        
        slickSettings: {
            dots: false,
            arrows: false,  
            autoplay: true,
            autoplaySpeed: 0,
            infinite: true,
            speed: 5000,
            fade: false,
            cssEase: 'linear',
            pauseOnHover: false,
            slide: 'div'
          
        }
      }
    },
    computed: {
        status (){
            return this.$store.state.authentication.status
        },
        user () {
            return this.$store.state.authentication.user
        },  
        alert () {
            return this.$store.state.alert
        }
    },
    created(){
    },
    watch:{
        $route (to, from ){
            // clear alert on location change
           // console.log(to);
            this.$store.dispatch('alert/clear');
            //console.log( $route );
/*
            alert('alert cleared');
            console.log(from);
            console.log(next);
*/
        }
    },
    methods: {
      toggleContact: function(e){
        e.preventDefault();
        $('#fastcontact').toggleClass('open');
      },
      toggleMenu: function(){
         this.mobilemenu = !this.mobilemenu
       },
      closeMenu: function(){
        console.log('close Menu clicked');
        this.mobilemenu = false;
        return;
      }
    }
    
};
</script>
<style lang="scss">
  
  /*
    color cats
    blau: #007eba
    gelb: #f8c63d
    gruen: #5eb245
    lila: #5f2a79
    rot: #d8222a
    
    gruen: #00853e
  */
  
  
  
#app {
  font-family: 'Montserrat', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.page { position: relative; padding: 3.888em 0 9.88888em 0; height: 100%; min-height: 100vh; }
.section { padding: 2.79999999em 0; }

#header { position: fixed; z-index: 10; top: 0; left: 0; right: 0; display: flex; 
  justify-content: space-between; align-items: center; padding: 0.63333em 0.63333333em; background: none; }
/* #header a:first-child { width: 3em; } */

.header-group { display: flex; }

/*
#backhome { display: block; width: 3.03333em; min-width: 3.0333333em; height: auto; padding: 0.3333em 0 0.7333em 0.2333em; margin-left: 0; }
@media screen and ( min-width: 40.0633333em) {
  #backhome { display: block; width: 6.09999em; min-width: 6.09999em; }
}
*/



#backhome { position: absolute;  z-index: 3; top: 0; left: 0; width: 6.09999em; height: 6.09999em; padding: 0.773333em 0 0.37333em; margin-left: 0; background: #fff; overflow: hidden; }
#backhome img { display: block; width: 6em; height: auto; }
#backhome:after { display: none !important; }
@media screen and ( min-width: 40.0633333em) {
  
  #header { padding: 0.8333333em; height: 6.09999em; }
  #backhome { display: block; width: auto; left: 0; width: 6.0999em; /* max-width: 4.3333em; */ padding: 1.173333em 0 0 0.47333em; overflow: hidden; transition: max-width 0.3s ease; }
  #backhome img { display: block; width: 5.133em; height: auto;  transform: scale(0.999); transition: transform 0.3s ease; transform-origin: 0 0; }
  #backhome:hover img { display: block; width: 5.133em; height: auto; transform: scale(1.02); transform-origin: 0 0; }

/*   #backhome:hover { max-width: 25em; } */

}



#metanav {  
  white-space: nowrap;
  padding: 0;
  display: flex;
  align-items: center;
  a {
    font-weight: bold;
    color: #00853e;
    margin: 0 0.433333em;
    
    &.router-link-exact-active {
      color: #00853e;
    }
  }
}

.icon { display: block; width: 1.6333rem; height: 1.633333rem; transition: transform 0.1s ease-in-out; position: relative; transform: scale(1.0011); }
.icon:hover { transform: scale(1.1111); }
.icon-favourite { background: url(/img/icons-red/favourite.svg) center center no-repeat; background-size: contain; }
.icon-favourite-full { background: url(/img/icons-red/favourite-full.svg) center center no-repeat; background-size: contain; }
.icon-user { background: url(/img/icons-red/user.svg) center center no-repeat; background-size: contain; }
.icon-help { background: url(/img/icons-red/help.svg) center center no-repeat; background-size: contain; }
.icon-basket { background: url(/img/icons-red/bag.svg) center center no-repeat; background-size: 125%; width: 1.6333rem; }
.icon-basket-full { background: url(/img/icons-red/bag-full.svg) center center no-repeat; background-size: 125%; width: 1.6333rem; }
.icon-search { background: url(/img/icons-red/search.svg) center center no-repeat; background-size: 115%; }
.icon-chevron-right { background: url(/img/icons-gray/chevron-right.svg) center center no-repeat; background-size: 100%; }

.icon-logout { background: url(/img/icons-red/exit.svg) center center no-repeat; background-size: contain; }

.icon-plus { background: url(/img/icons-green/add.svg) center center no-repeat; background-size: contain; }
.icon-minus { background: url(/img/icons-green/remove.svg) center center no-repeat; background-size: contain; }
.icon-remove { background: url(/img/icons-red/delete.svg) center center no-repeat; background-size: contain; }


#metanav a { position: relative; }
span.counter { background: none; color: #e30613; font-size: 0.7rem; text-decoration: none;
  position: absolute; top:-0.3rem; left: -0.63333rem; width: 1.3333rem; height: 1.33333rem; line-height: 1.33333rem; text-align: center;
  border-radius: 1rem;
}
.icon-favourite-full + span.counter { color: yellow !important; background: green;}
.icon-basket-full + span.counter { color: yellow !important; background: green; }


#metanav .userdata { display: flex; align-items: center; width: auto; height: auto; padding: 0 0.933333em; transition: transform 0.1s ease-in-out; font-weight: normal;  line-height: 1;  text-decoration: none !important; }
#metanav .userdata .kdn { display: none; text-decoration: none; font-size: 0.8rem; margin: 0.555em 0 0.333rem 0.33333rem; font-weight: bold; color: #333;}

@media screen and ( min-width: 40.0633333em) {
  #metanav .userdata .kdn { display: block; }
}







#maincontent { min-height: 100vh; position: relative; }

#sidebar { position: absolute; top: 6.09999em; left: 0; width: 6.09999em; z-index: 9; }
#sidebar { transform: translateX(-6em); transition: transform 0.2s ease; }
#sidebar.mobilemenuopen { transform: translateX(0) }

#productnav { height: auto; width: 100%; min-width: 6em; background: none; }
.navbox { height: 100%; display: flex; flex-direction: column; align-items: stretch; background: transparent;}
#productnav a { display: block; width: 100%; color: #fff; text-decoration: none; font-weight: 600; text-align: right; position: relative; text-transform: uppercase; text-indent: -9999px; }
#productnav a .link-label { position: absolute; bottom: 0; left: 0; padding: 5%; display: none; }
#productnav a:nth-child(1) { background: #007eba; }
#productnav a:nth-child(2) { background: #f8c63d; }
#productnav a:nth-child(3) { background: #5eb245; }
#productnav a:nth-child(4) { background: #5f2a79; }
#productnav a:nth-child(5) { background: #d8222a; }
#productnav a:nth-child(6) { background: #008d51; }

@media screen and ( min-height: 600px) {
  #sidebar { position: fixed; }
}

.sidebar-button { display: block; position: absolute; width: 12em; left: 8.33333em; top: 0em; color: #fff; font-size: 0.8rem;  padding: 1.4333333em 0.4333333em ; text-indent: 0; background: rgba(255,255,255,0.8) url(/img/icons-green/chevrons-right.svg) left center no-repeat; background-size: 4.4em; cursor: pointer; color: #00853e; }

.openmenu { 
    display:block; width: 2.777em; max-width: 3em; 
    background:  url(/img/icons-green/hamburger.svg) -8px center no-repeat; background-size: 2.4em; 
    cursor: pointer; color: #00853e; text-indent: -9999px; margin-left: 0.83333em; 
    }

@media screen and ( min-width: 768px) {
  .openmenu { display: none; }
  #sidebar { transform: translateX(0); top: 6.09999em; }
  .sidebar-button { display: none; }
}

  .mobile-icon-search { display: none; }


  h2,h3 { font-weight: bold; }
  h1 { font-weight: 600; margin: 0; padding: 0.44333em 0; color: #00853e; font-size: 1.433333rem; text-transform: uppercase; }
  .loginpage h1 { padding: 0; }
  p { color: #00853e; line-height: 1.7rem; font-size: 1.1rem; }


  .columns { margin: 0 0 0 0.63333em; }
  .columns img { display: block; max-width: 100%; border-radius: 3px; overflow: hidden;  }  
  .column { display: block; padding: 0.9333333em; text-align: left; }
  @media screen and ( min-width: 768px) {    
    .column { display: block; padding: 0.9333333em; text-align: left; }
    .columns { max-width: 64em; margin: 0 0 0 7.63333em; }
    .columns.max { max-width: 100%; margin: 0 auto; }
    .columns.max .column { padding: 0.9333333em 0; }
    .columns.max img { padding: 0; }
    .columns.flex { display: flex; }
    .columns.wrap { flex-wrap: wrap; }
    .columns.valign-middle { align-items: center; }
    .columns.align-center { justify-content: center; }
    .columns.space-between { justify-content: space-between; }
    .columns.valign-top { align-items:flex-start; }
    .columns.half .column { flex: 1 1 50%; max-width: 50%; }
    .columns.third .column { flex: 1 1 33.3333%; max-width: 33.3333%; }
    .columns.quarter .column { flex: 1 1 25%; max-width: 25%; }
    img.round { border-radius: 100%; max-width: 20em; margin: 0 auto; }
    .column.text-right { text-align: right; }
    
    #productnav a { opacity: 1; transform: scale(1.001) translateX(0); transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out; }
    #productnav a:hover { opacity: 1; transform: scale(0.9181) translateX(0); }
  }


.breadcrumb { color: #999; padding: 0.933333em 0 0; }
.breadcrumb a { color: #999; text-decoration: none; font-size: 0.7rem; text-transform: uppercase; transition: color 0.2s ease-in-out; }
.breadcrumb span { color: #999; text-decoration: none; font-size: 0.7rem; text-transform: uppercase; transition: color 0.2s ease-in-out; }
.breadcrumb a:hover { color: #00853e; }
.breadcrumb i.icon { display: inline-block; border: 0 solid red; height: 0.5rem;  }


/*
#fastcontact { position: fixed; bottom: 0; left: 0; right: 0; text-align: center;  }
#fastcontact a { display: inline-block; color: #fff; text-decoration: none; font-weight: bold; padding: 0.933333333em 0.933333333em 0.933333333em 3.4333333333em; background: #00853e; cursor: pointer; 
  }

@media screen and ( min-width: 768px) {
  #fastcontact { background: transparent; left: auto; bottom: auto; top: 16%; transform: translateX( 100%  ); transition: transform 0.3s ease; border-radius: 3px 0 0 3px; }
  #fastcontact:hover { transform: translateX( 0 ) }
  #fastcontact a { display: block; text-align: left; margin-top: 1px ; transition: background-color 0.3s ease-in-out; }
  #fastcontact a:hover { background-color: #09c024 !important; }
  #fastcontact h3 { background: #00853e; color: #fff; margin: 0; height: 2.999999em; padding-top: 1em; }
  #fastcontact:before { content:""; background: #00853e url(/img/icons-white/help.svg) 0.933333333em center no-repeat; background-size: 1.9em;  left:-3.499999em; width: 3.49999em; height: 3.49999em; position: absolute; }

  #fastcontact a[href^="tel"] { background: #00853e url(/img/icons-white/phone.svg) 0.933333333em center no-repeat; background-size: 1.6em; }
  #fastcontact a[href^="mailto"] { background: #00853e url(/img/icons-white/envelope-alt.svg) 0.933333333em center no-repeat; background-size: 1.6em; }
}
*/

#footer { position: absolute; bottom: 0; left: 0; right: 0; color: #00853e; background: #f3f4f5; padding-bottom: 2.8888em; line-height: 1.77777rem;}
#footer nav { white-space: nowrap; }
@media screen and ( min-width: 768px) {
  #footer { padding-bottom: 0em;  }
  #footer .columns { justify-content: flex-end; } 
  #footer .columns .column nav { display: inline-block; } 
  #footer .columns .column nav:before { content:" - "; }
}
  #footer nav a { display: inline-block; color: #00853e; transition: color 0.3s ease; } 
  #footer nav a:hover { color: #333 }




#fastcontact { position: fixed; bottom: 0.9333em; right: 1.3333em; text-align: center; z-index: 100; overflow: visible; }
#fastcontact a.fastcontact-trigger { position: relative; z-index: 4; display: inline-block; color: #fff; 
  text-decoration: none; font-weight: bold; width: 4em; height: 4em; border-radius: 4em; 
  background: #00853e url(/img/icons-white/phone.svg) center center no-repeat; background-size: 1.99em; cursor: pointer;
  border: 0px solid #fff;
  transform: scale(0.8);
  transition: all 0.3s ease;
  }
#fastcontact a:after { display: none !important; }


.contact-info-box { 
  position: fixed; /* top: 50%; transform: translate(0,-50%); right: 0.333em; left: 0.333em;  */ 
  width: auto; max-width: 100vw;  
  overflow: hidden;
  height: 0;
  opacity: 0;
  transition: opacity 0.3s ease;
  top: 0; left: 0; right: 0; bottom:0; z-index: 2; background: rgba(0,0,0,0.3);
}

#fastcontact.open .contact-info-box { opacity: 1; height: auto;  z-index: 200; }
#fastcontact.open { z-index: 201; }
#fastcontact.open a.fastcontact-trigger { z-index: 202; }

.contact-info-box-inner { position: absolute; bottom: 5.71111em; right: 1.3333em; left: 1.3333em; background: #fff; border: 0 solid #fff; border-radius: 2px; overflow: visible; box-shadow: 0 0 10px rgba(0,0,0,0.1); }

.contact-info-box-inner:before { 
    position: absolute; right: 1.4333em; bottom: -8px; 
    content: " "; 
    border-top: 8px solid #fff; border-bottom: 0; border-left: 8px solid transparent; 
    border-right: 8px solid transparent; 
    }

.contact_images { margin: 0; padding: 0; list-style: none; }

.contact-info-box-content { padding: 0.3333em 1.4333em;  }
.contact-info-box p { text-align: left; font-size: 0.9rem; line-height: 1.2; color: #454545; }
.contact-info-box h2 { text-align: left; padding: 0.8133em 0; margin: 0; color: #00853e; }
.contact-info-box p a { color: #00853e; }

.contact-info-box img { display: block; width: 100%; max-width: 100%; height: auto; }

@media screen and ( min-width: 768px) {
  #fastcontact { bottom: auto; top: 0.9333em; }
  .contact-info-box-inner { position: absolute; top: 1.3111em; right: 5.9111em; bottom: auto; left: auto;  max-width: 24em; }
  .contact-info-box-inner:before { 
    position: absolute; right: -8px; top: 19px; bottom: auto;
    content: " "; 
    border-right: 0; border-left: 8px solid #fff; border-top: 8px solid transparent; 
    border-bottom: 8px solid transparent; 
    }
  .open .contact-info-box { opacity: 1; height: auto; box-shadow: 0 0 10px rgba(0,0,0,0.1); }
  #fastcontact a.fastcontact-trigger:hover { transform: scale(0.83); }
}







.hamburger { position: fixed; top: 0.9333em; right: 1.3333em;  }

.hamburger {
  
  outline: none !important;
  height: 4em;
  width: 4em;
  padding: 0.75em;
  border-radius: 100%;
  display: inline-block;
  cursor: pointer;
  transition-property: opacity, filter;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  font: inherit;
  color: inherit;
  text-transform: none;
  background-color: #e30513;
  border: 0;
  margin: 0;
  overflow: visible; 
  transform: scale(0.8); transition: transform 0.2s;
  }


  .hamburger:hover {
    transform: scale(0.83) }
  .hamburger.is-active:hover {
    opacity: 0.93; }
  .hamburger.is-active .hamburger-inner,
  .hamburger.is-active .hamburger-inner::before,
  .hamburger.is-active .hamburger-inner::after {
    background-color: #fff; }

.hamburger-box {
  width: 2.5em;
  height: 28px;
  display: inline-block;
  position: relative; 
  background: none;
  }

.hamburger-inner {
  display: block;
  top: 50%;
  margin-top: -2px; }
  .hamburger-inner, .hamburger-inner::before, .hamburger-inner::after {
    width: 2.5em;
    height: 4px;
    background-color: #fff;
    border-radius: 0;
    position: absolute;
    transition-property: transform;
    transition-duration: 0.15s;
    transition-timing-function: ease; }
  .hamburger-inner::before, .hamburger-inner::after {
    content: "";
    display: block; }
  .hamburger-inner::before {
    top: -10px; }
  .hamburger-inner::after {
    bottom: -10px; }
    
.hamburger--collapse .hamburger-inner {
  top: auto;
  bottom: 0;
  transition-duration: 0.13s;
  transition-delay: 0.13s;
  transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); }
  .hamburger--collapse .hamburger-inner::after {
    top: -20px;
    transition: top 0.2s 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1), opacity 0.1s linear; }
  .hamburger--collapse .hamburger-inner::before {
    transition: top 0.12s 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1), transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19); }

.menu-visible .hamburger--collapse .hamburger-inner {
  transform: translate3d(0, -10px, 0) rotate(-45deg);
  transition-delay: 0.22s;
  transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }
 .menu-visible .hamburger--collapse .hamburger-inner::after {
    top: 0;
    opacity: 0;
    transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333), opacity 0.1s 0.22s linear; }
  .menu-visible .hamburger--collapse .hamburger-inner::before {
    top: 0;
    transform: rotate(-90deg);
    transition: top 0.1s 0.16s cubic-bezier(0.33333, 0, 0.66667, 0.33333), transform 0.13s 0.25s cubic-bezier(0.215, 0.61, 0.355, 1); }


@media screen and ( min-width: 768px) {
  .hamburger { display: none; }
}




</style>
